import WestRoundedIcon from '@mui/icons-material/WestRounded';
import EastRoundedIcon from '@mui/icons-material/EastRounded';
import { IconButton } from '@mui/material';
import { FlexRow } from '../Layout';
import { useSharedTFunction } from '@shared/i18n';

interface Props {
  disableNext: boolean;
  disablePrevious: boolean;
  handleNext: () => void;
  handlePrevious: () => void;
}

export default function PaginationArrows({
  disableNext,
  disablePrevious,
  handleNext,
  handlePrevious,
}: Props) {
  const t = useSharedTFunction();
  return (
    <FlexRow gap={2}>
      <IconButton
        disabled={disablePrevious}
        onClick={handlePrevious}
        aria-label={t('shared.previous')}
        data-testid="pagination-arrow-previous"
      >
        <WestRoundedIcon />
      </IconButton>
      <IconButton
        disabled={disableNext}
        onClick={handleNext}
        aria-label={t('shared.next')}
        data-testid="pagination-arrow-next"
      >
        <EastRoundedIcon />
      </IconButton>
    </FlexRow>
  );
}
